import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5cf3ca15"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "detail"
};
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  key: 1
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));

const _hoisted_7 = {
  class: "apply"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_commitment_detail = _resolveComponent("commitment-detail");

  const _component_apply_job = _resolveComponent("apply-job");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.jobDetail.detail, data => {
    return _openBlock(), _createElementBlock("div", {
      class: "detail-content",
      key: data.key
    }, [_createElementVNode("h2", {
      innerHTML: data.title
    }, null, 8, _hoisted_2), typeof data.content === 'string' ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      innerHTML: data.content
    }, null, 8, _hoisted_3)) : data.content instanceof Array ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.content, c => {
      return _openBlock(), _createElementBlock("li", {
        key: c
      }, [_hoisted_5, _createElementVNode("span", null, _toDisplayString(c), 1)]);
    }), 128))])) : (_openBlock(true), _createElementBlock(_Fragment, {
      key: 2
    }, _renderList(data.content, (value, key) => {
      return _openBlock(), _createElementBlock("div", {
        key: key
      }, [_createElementVNode("h3", null, _toDisplayString(key), 1), _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, c => {
        return _openBlock(), _createElementBlock("li", {
          key: c
        }, [_hoisted_6, _createElementVNode("span", null, _toDisplayString(c), 1)]);
      }), 128))])]);
    }), 128))]);
  }), 128)), _createVNode(_component_commitment_detail), _createElementVNode("div", _hoisted_7, [_createVNode(_component_apply_job)])]);
}